export const RESET = 'INFO_UPDATE_RESET';
export const SET_ERROR = 'INFO_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'INFO_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'INFO_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'INFO_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'INFO_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'INFO_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/info/update/mutation_types.js